import { Trans, withI18n } from '@lingui/react'
import { bool, oneOf, string } from 'prop-types'
import { compose } from 'redux'

import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import InputTextWithWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import Notification from 'views/components/molecules/Notification'
import Select from 'views/components/molecules/Select'
import TextareaWithFloatingLabel from 'views/components/molecules/TextareaWithFloatingLabel'
import { PRODUCT_CONSULTATION_MESSAGE_FORM_CLASS } from 'views/components/organisms/ContactShopApothekeModal/consts'
import {
  ORDER_TYPE,
  PRODUCT_TYPE,
} from 'views/components/organisms/ProductConsultation/ProductConsultationCallback/helpers'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import withMountPoints from 'views/enhancers/withMountPoints'
import { i18nType, mountPointsType } from 'views/utils/propTypes'

const MESSAGE_FORM = {
  PZN: 'productCode',
  FIRST_NAME: '§emailForm.firstName',
  LAST_NAME: '§emailForm.lastName',
  MESSAGE: '§emailForm.message',
  EMAIL: '§emailForm.email',
  SUBJECT: '§emailForm.subject',
  TYPE: 'type',
  ORDER_ID: 'orderId',
  ORDER_ID_LMS: '§emailForm.orderId',
}

const ProductConsultationMessage = ({
  productId,
  scope,
  i18n,
  mountPoints,
  type,
  showOrderAndSubject,
}) => {
  const options = {
    id: 'subject',
    name: MESSAGE_FORM.SUBJECT,
    label: i18n._('general.label.subject'),
    options: [
      { value: '', text: '' },
      {
        value: 'addressChange',
        text: i18n._('contactForm.select.item.changeDeliveryAddress'),
      },
      {
        value: 'nameChange',
        text: i18n._('contactForm.select.item.changeName'),
      },
      {
        value: 'bankDetails',
        text: i18n._('contactForm.select.item.bankDetails'),
      },
      {
        value: 'orderEnquiry',
        text: i18n._('contactForm.select.item.orderQuestion'),
      },
      {
        value: 'additionalOrder',
        text: i18n._('contactForm.select.item.additionalOrder'),
      },
      { value: 'complaint', text: i18n._('contactForm.select.item.claim') },
      { value: 'returns', text: i18n._('contactForm.select.item.returns') },
      {
        value: 'pharmaAdvice',
        text: i18n._('contactForm.select.item.consultation'),
      },
      {
        value: 'priceRequest',
        text: i18n._('contactForm.select.item.priceInquiry'),
      },
      {
        value: 'productRequest',
        text: i18n._('contactForm.select.item.productInquiry'),
      },
      {
        value: 'suggestions',
        text: i18n._('contactForm.select.item.suggestions'),
      },
      {
        value: 'others',
        text: i18n._('contactForm.select.item.miscellaneous'),
      },
    ],
  }
  return (
    <>
      <Form
        className={PRODUCT_CONSULTATION_MESSAGE_FORM_CLASS}
        name="message-form"
        data-clientside-hook="formValidation productConsultationMessageForm"
      >
        <input
          type="hidden"
          name={type === 'product' ? MESSAGE_FORM.PZN : MESSAGE_FORM.ORDER_ID}
          value={productId}
        />
        <input type="hidden" name={MESSAGE_FORM.TYPE} value={type} />
        <ul className="l-grid l-grid--tight">
          <li className="l-grid__item l-col--6-of-12 u-margin--bottom">
            <InputTextWithWithFloatingLabel
              id={`${scope}-MessageForm-firstname`}
              name={MESSAGE_FORM.FIRST_NAME}
              inputType="text"
              required
            >
              <Trans id="general.label.firstName" />
            </InputTextWithWithFloatingLabel>
          </li>
          <li className="l-grid__item l-col--6-of-12 u-margin--bottom">
            <InputTextWithWithFloatingLabel
              name={MESSAGE_FORM.LAST_NAME}
              id={`${scope}-MessageForm-lastname`}
              inputType="text"
              required
            >
              <Trans id="general.label.surname" />
            </InputTextWithWithFloatingLabel>
          </li>
          <li className="l-grid__item u-margin--bottom">
            <InputTextWithWithFloatingLabel
              name={MESSAGE_FORM.EMAIL}
              id={`${scope}-MessageForm-eMail`}
              inputType="email"
              required
            >
              <Trans id="general.label.email" />
            </InputTextWithWithFloatingLabel>
          </li>
          {showOrderAndSubject && (
            <>
              <li className="l-grid__item l-col--6-of-12 u-margin--bottom">
                <Select
                  {...options}
                  floatingLabel
                  name={MESSAGE_FORM.SUBJECT}
                />
              </li>
              <li className="l-grid__item u-margin--bottom l-col--6-of-12">
                <InputTextWithWithFloatingLabel
                  name={MESSAGE_FORM.ORDER_ID_LMS}
                  id={`${scope}-MessageForm-orderId`}
                  inputType="text"
                >
                  <Trans id="general.form.label.orderNumber" />
                </InputTextWithWithFloatingLabel>
              </li>
            </>
          )}
          <li className="l-grid__item u-margin-x-large--bottom">
            <TextareaWithFloatingLabel
              name={MESSAGE_FORM.MESSAGE}
              id={`${scope}-MessageForm-message`}
              required
            >
              <Trans id="MessageForm.label.message" />
            </TextareaWithFloatingLabel>
          </li>
          <li className="l-grid__item u-margin--bottom">
            <p>
              <Trans id="general.form.label.mandatoryFieldIndicator" />
            </p>
            <TransWithHtml
              id="general.label.privacyPolicyAgreement"
              element="p"
              values={{ url: mountPoints.getPrivacySecurity() }}
            />
          </li>
          <li
            className="l-grid__item u-margin--bottom u-hidden"
            data-clientside-hook="productConsultationMessageError"
          >
            <Notification
              type="error"
              label={i18n._('product.consultation.message.error')}
            />
          </li>
          <li className="l-grid__item u-margin--bottom">
            <div className="u-text-align--right">
              <Button name="CallbackForm-message" inline type="submit">
                <Trans id="product.consultation.button.submitMessage" />
              </Button>
            </div>
          </li>
        </ul>
      </Form>

      <div
        className="u-hidden"
        data-clientside-hook="productConsultationMessageSuccess"
      >
        <Notification
          type="success"
          label={i18n._('product.consultation.message.success')}
        />
      </div>
    </>
  )
}

ProductConsultationMessage.propTypes = {
  i18n: i18nType.isRequired,
  productId: string,
  scope: string,
  mountPoints: mountPointsType.isRequired,
  type: oneOf([PRODUCT_TYPE, ORDER_TYPE]).isRequired,
  showOrderAndSubject: bool,
}

ProductConsultationMessage.defaultProps = {
  scope: 'global',
  showOrderAndSubject: false,
  productId: '',
}

export default compose(withI18n(), withMountPoints)(ProductConsultationMessage)
